<template>
  <div>
    <ProvidersListHero />

    <v-container>
      <div class="provider-grid">
        <CategorySection
          :title="categoryTitle"
          :description="description"
          :category="category"
          :providers="providers">

          <template #more-link>
            <hr />

            <button
              v-if="!areMoreProviders"
              class="default-btn link"
              @click="getProviders">
              Show More
            </button>
          </template>
        </CategorySection>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import CategorySection from '../../components/CategorySection'
import ProvidersListHero from '../../components/ProvidersListHero'

export default {
  name: 'ProvidersListAll',
  components: {
    CategorySection,
    ProvidersListHero,
  },

  props: {
    category: String,
  },

  data: () => ({
    providers: [],
    totalItems: 0,
    loading: false,

    categories: [
      'attorney',
      'eo',
      'compliance',
      'cpa',
    ],
  }),

  computed: {
    ...mapGetters('feathers', ['apiProviders']),
    ...mapState({
      providerDescriptions: state => state.providerDescriptions || {},
    }),

    description () {
      return this.providerDescriptions[this.category] || ''
    },

    areMoreProviders () {
      return this.providers.length >= this.totalItems
    },

    categoryTitle () {
      switch (this.category) {
        case 'attorney': return 'Attorneys'
        case 'eo': return 'E&O Providers'
        case 'compliance': return 'Compliance Consultants'
        case 'cpa': return 'CPAs'
        default: return ''
      }
    },
  },

  created () {
    if (!this.categories.includes(this.category)) {
      return this.$router.replace({ name: 'ProvidersList' })
    }

    document.title = `Providers | ${this.categoryTitle}`
    this.$gtag.pageview({ page_path: document.title })

    this.getProviders()
  },

  methods: {
    async getProviders () {
      if (this.loading) return
      this.loading = true

      try {
        const results = await this.apiProviders.find({
          query: {
            type: this.category,
            $limit: 5,
            $skip: this.providers.length,
            $sort: {
              reviewScore: -1,
            },
          },
        })

        this.providers.push(...results.data)
        this.totalItems = results.total
      } catch (error) {
        this.addErrorAlert('Sorry, there was an error getting provider information, please try reloading the page')
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.provider-grid {
  margin: 40px 0 100px;
}

hr {
  display: block;
  height: 2px;
  width: 100%;
  margin-top: 10px;

  border: 1px solid #D1D1D1;
}
</style>
